import { BackButton } from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useActivityLogDetails } from "./useActivityLogDetails";
import { defaultDateDisplay } from "../../../../../helpers";
import { activityLogMap } from "../../../../../routes/activityLogMap";
import { Link } from "react-router-dom";
import { ActivityLogRecords } from "../../../../../components/secondaryComponents/ActivityLogs";
import { useMemo } from "react";

export const ActivityLogDetails = () => {
  const {
    activityLogDetails,
    isLoadingActivity,
    isLoadingRecords,
    activityLogRecords,
  } = useActivityLogDetails();
  const descriptionList = activityLogDetails?.action?.split(
    activityLogDetails?.resource_id || "-",
  );

  const filteredActivityLogRecords = useMemo(() => {
    return activityLogRecords?.filter((item) => item?.action !== "created");
  }, [activityLogRecords]);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Settings - Activity Log Details"
      description="View activity log details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <BackButton />
          </div>

          <div>
            <h4 className="mb-0">{activityLogDetails?.id}</h4>

            <secondaryComponents.LoaderHelper
              isLoading={isLoadingActivity}
              classNames="my-5"
            >
              <div className={globalStyles.gridDetailsView}>
                <div>
                  <h6>Created At</h6>
                  <span className="gray--text">
                    {defaultDateDisplay(activityLogDetails?.event_time)}
                  </span>
                </div>
                <div>
                  <h6>User</h6>
                  <span className="gray--text">
                    {activityLogDetails?.initiator?.first_name || "N/A"}
                  </span>
                </div>
                <div>
                  <h6>Role</h6>
                  <span className="gray--text">
                    {activityLogDetails?.role || "N/A"}
                  </span>
                </div>
                {/* <div>
                  <h6>Resource ID</h6>

                  {activityLogDetails?.resource_id &&
                  activityLogMap?.[activityLogDetails?.module?.name] ? (
                    <Link
                      to={activityLogMap?.[
                        activityLogDetails?.module?.name
                      ]?.details({
                        id: activityLogDetails?.resource_id,
                      })}
                      className="purple--text"
                    >
                      {activityLogDetails?.resource_id}
                    </Link>
                  ) : (
                    <span className="gray--text">
                      {activityLogDetails?.resource_id || "N/A"}
                    </span>
                  )}
                </div> */}
                <div>
                  <h6>Module</h6>

                  {activityLogMap?.[activityLogDetails?.module?.name] ? (
                    <>
                      <Link
                        to={
                          activityLogMap?.[activityLogDetails?.module?.name]
                            ?.home
                        }
                        className="purple--text"
                      >
                        {activityLogDetails?.module?.name}
                      </Link>
                    </>
                  ) : (
                    <span className="gray--text">
                      {activityLogDetails?.module?.name || ""}
                    </span>
                  )}
                </div>

                <div>
                  <h6>Action</h6>
                  <span className="gray--text">
                    {activityLogDetails?.resource_id &&
                    activityLogMap?.[activityLogDetails?.module?.name] ? (
                      <>
                        {descriptionList?.[0]}(
                        <Link
                          to={activityLogMap?.[
                            activityLogDetails?.module?.name
                          ]?.details({
                            id: activityLogDetails?.resource_id,
                          })}
                          className="purple--text"
                        >
                          {activityLogDetails?.resource_id}
                        </Link>
                        ){descriptionList?.[1]}
                      </>
                    ) : (
                      activityLogDetails?.action || "N/A"
                    )}
                  </span>
                </div>
                <div>
                  <h6>Metadata</h6>
                  <span className="gray--text">
                    {activityLogDetails?.ip_address}
                    <br />
                    {activityLogDetails?.browser}
                  </span>
                </div>
                <div>
                  <h6>OS</h6>
                  <span className="gray--text">
                    {activityLogDetails?.os || "N/A"}
                  </span>
                </div>
              </div>
            </secondaryComponents.LoaderHelper>
          </div>

          <secondaryComponents.LoaderHelper
            classNames="mt-5"
            isLoading={isLoadingRecords}
          >
            {filteredActivityLogRecords?.map((record) => (
              <div key={record?.id}>
                <h5>
                  {record?.model_name}
                  {"-"}
                  <span className="purple--text">
                    {record?.object_label || "N/A"}
                  </span>
                  : {defaultDateDisplay(record?.event_time)}
                </h5>

                <ActivityLogRecords
                  activityLogRecords={record?.updated_fields}
                />
              </div>
            ))}
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
